import { object } from 'yup';

export const getDefaultFormValues = () => {
  return {};
};

export const getFormValidationScheme = () => {
  return object();
};
